// PAPERLIKE CUSTOM — Paperlike-built, no vanilla equivalent

// NEWSLETTER MODAL | CUSTOM ASSET — NOT A NATIVE IMPACT THEME FILE. Safe from theme updates.

if (!window.customElements.get('newsletter-modal')) {
  class NewsletterModal extends HTMLElement {
    connectedCallback() {
      const settingsEl = this.querySelector('[data-newsletter-modal-settings]');
      if (!settingsEl) return;

      this._settings = JSON.parse(settingsEl.textContent);
      this._overlay = this.querySelector('.newsletter-modal__overlay');
      this._closeBtn = this.querySelector('[data-close]');
      this._backdrop = this.querySelector('.newsletter-modal__backdrop');
      this._handleEscape = (e) => { if (e.key === 'Escape') this.close(); };

      this._closeBtn?.addEventListener('click', () => this.close());
      this._backdrop?.addEventListener('click', () => this.close());

      const { modal_action, anchor_id, popup_delay, popup_dismiss_days } = this._settings;

      if (modal_action === 'option_1' && anchor_id) {
        // Link trigger: any <a href="#anchor-id"> anywhere on the page opens this modal
        document.querySelectorAll(`a[href="${anchor_id}"]`).forEach(link => {
          link.addEventListener('click', (e) => {
            e.preventDefault();
            this.open();
          });
        });
      } else if (modal_action === 'option_2') {
        this._initTimedTrigger(popup_delay, popup_dismiss_days);
      }
    }

    _initTimedTrigger(delay, dismissDays) {
      const key = `newsletter-modal:${this._settings.id}:shown`;
      const popupShown = localStorage.getItem(key);

      if (!popupShown || dismissDays == 0) {
        setTimeout(() => this.open(), delay);
        return;
      }

      const daysPassed = Math.floor((Date.now() - parseInt(popupShown)) / (24 * 60 * 60 * 1000));
      if (daysPassed >= dismissDays) {
        setTimeout(() => this.open(), delay);
      }
    }

    open() {
      document.body.classList.add('newsletter-modal-active');
      this._overlay.style.display = 'flex';
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this._overlay.classList.add('is-visible');
        });
      });
      document.addEventListener('keydown', this._handleEscape);
      this._overlay.querySelector('button, input, select, textarea, [tabindex]')?.focus();
    }

    close() {
      const key = `newsletter-modal:${this._settings.id}:shown`;
      localStorage.setItem(key, Date.now().toString());

      this._overlay.classList.remove('is-visible');
      this._overlay.addEventListener('transitionend', () => {
        this._overlay.style.display = 'none';
        document.body.classList.remove('newsletter-modal-active');
      }, { once: true });
      document.removeEventListener('keydown', this._handleEscape);
    }
  }

  customElements.define('newsletter-modal', NewsletterModal);
}
